<template>
  <div class="step-header" v-bind:class="{ 'step-header--inline': inLine }">
      <h1 class="step-header__title">
          {{formattedHeaderText}}
      </h1>
      <span class="step-header__sub-title" v-html="formattedSubHeaderText"></span>
  </div>
</template>

<script lang='ts'>
import { Component, Prop, Vue } from 'vue-property-decorator';
import { tokenService } from '../../services/TokenService';

@Component
export default class StepHeaderComponent extends Vue {
  @Prop({ default: '' })
  public headerText!: string;

  @Prop({ default: '' })
  public subHeaderText!: string;

  @Prop({ default: false })
  public inLine!: boolean;

  public get formattedHeaderText() {
    return tokenService.replaceToken(this.headerText);
  }

  public get formattedSubHeaderText() {
    return tokenService.replaceToken(this.subHeaderText);
  }
}
</script>
